import { Assets } from './Assets'

export const CreditCardLiabilities = ({ liabilities, handleOnClick }) => {
  const creditCardLiabilities = (liabilities || []).filter(
    (option) => option.subType === CreditCardLiabilities.targetCategory
  )
  return (
    <Assets
      assets={creditCardLiabilities}
      handleOnClick={handleOnClick}
      category={CreditCardLiabilities.targetCategory}
    />
  )
}
CreditCardLiabilities.targetCategory = 'creditcard'
